import { createRoute } from "@tanstack/react-router";
import { appRoute } from "../../shell/routes";
import { ActivityPage } from "./ActivityPage";
import { SecurityPage } from "./SecurityPage";

export const securitySettingsRoute = createRoute({ getParentRoute: () => appRoute, path: "settings/security", component: SecurityPage });

export const activitySettingsRoute = createRoute({ getParentRoute: () => appRoute, path: "settings/activity", component: ActivityPage });
